module.exports = __webpack_public_path__ + "static/media/prototype-cerveja-me-1.21cefa83.mp4";